var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mark-container"},[_c('div',{staticClass:"marker-favorites"},[(_vm.isMultiple)?_vm._l((_vm.value.color),function(color){return _c('div',{key:color,staticClass:"marker-part",style:({ backgroundColor: color })})}):[_c('div',{staticClass:"marker-part",style:({ backgroundColor: _vm.value.color })})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }